module.exports = __webpack_public_path__ + "static/img/cabecera6.906125e6.jpg";